import React from 'react';
import Tooltip from 'rc-tooltip';

import Commenter from 'buyside/components/presentation/Feed/CommenterList/Commenter/commenter';

class CommenterPopover extends React.Component {
  constructor(props) {
    super(props);
  }

  renderPopoverContent() {
    const { comments } = this.props;
    return (
      <>
        {comments.map((comment, index) => {
          return (
            <div key={index}>
              <Commenter comment={comment} articleCaps userLink={false} />
            </div>
          );
        })}
      </>
    );
  }

  render() {
    const { comments } = this.props;

    return (
      <span
        data-testid="commenter-popover"
        onMouseOver={() => this.togglePopover(true)}
        onMouseOut={() => this.togglePopover(false)}
      >
        <Tooltip overlay={this.renderPopoverContent()} placement="top">
          <span>{comments.length} others</span>
        </Tooltip>
      </span>
    );
  }
}

export default CommenterPopover;
